// extracted by mini-css-extract-plugin
export default {"app":"LuCrx0ri7eGynfprMnnj"};